import { useEffect, useState } from "react";
import { Download, FileText, Video, Image as ImageIcon, File as FileIcon, Folder } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const fileUrl = (u) => `${BACKEND}${u}`;
const fmt = (b) => (b >= 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round((b || 0) / 1024))} KB`);
const iconFor = (c) => (c === "video" ? Video : c === "image" ? ImageIcon : c === "document" ? FileText : FileIcon);

export default function Downloads() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Downloads & Media — Rani Super Market";
    fetch(`${BACKEND}/api/media`).then((r) => r.json())
      .then((d) => setItems(Array.isArray(d) ? d : [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-3 sm:px-4 py-6" data-testid="downloads-page">
      <div className="flex items-center gap-3 mb-5">
        <div className="w-11 h-11 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center"><Folder size={22} /></div>
        <div>
          <h1 className="text-xl sm:text-2xl font-extrabold text-slate-900">Downloads &amp; Media</h1>
          <p className="text-sm text-slate-500">Brochures, catalogs, product videos aur documents — free download karein.</p>
        </div>
      </div>

      {loading ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {Array.from({ length: 8 }).map((_, i) => <div key={i} className="aspect-[4/3] bg-white rounded-xl border border-slate-200 animate-pulse" />)}
        </div>
      ) : items.length === 0 ? (
        <div className="text-center py-20 bg-white rounded-2xl border border-slate-200" data-testid="downloads-empty">
          <Folder className="mx-auto text-slate-300" size={48} />
          <p className="mt-3 text-slate-500 font-medium">Abhi koi file available nahi.</p>
          <p className="text-slate-400 text-sm">Jaldi hi brochures aur catalogs yahan milenge.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="downloads-grid">
          {items.map((f) => {
            const Icon = iconFor(f.category);
            return (
              <div key={f.id} data-testid={`download-card-${f.id}`} className="bg-white rounded-xl border border-slate-200 overflow-hidden hover:shadow-md transition-shadow flex flex-col">
                <div className="aspect-[4/3] bg-slate-50 flex items-center justify-center overflow-hidden">
                  {f.category === "image"
                    ? <img src={fileUrl(f.url)} alt={f.filename} className="w-full h-full object-cover" />
                    : f.category === "video"
                      ? <video src={fileUrl(f.url)} className="w-full h-full object-cover" muted preload="metadata" />
                      : <Icon size={44} className="text-emerald-500" />}
                </div>
                <div className="p-3 flex flex-col flex-1">
                  <div className="text-sm font-semibold text-slate-800 truncate" title={f.filename}>{f.filename}</div>
                  <div className="text-[11px] text-slate-400 uppercase mb-3">{f.category} · {fmt(f.size)}</div>
                  <a href={`${fileUrl(f.url)}?download=1`} download data-testid={`download-btn-${f.id}`}
                    className="mt-auto inline-flex items-center justify-center gap-1.5 bg-emerald-600 text-white text-sm font-bold px-3 py-2 rounded-lg hover:bg-emerald-700">
                    <Download size={15} /> Download
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
